var hideCookieBannerKey = 'hideCookieBanner';

$('#cookie-banner-close').click(function(e) {
    e.preventDefault();

    $('#cookie-banner').addClass('hide');
    $('footer').css('margin-bottom', '0');

    var expires = new Date();
    expires.setMonth(expires.getMonth() + 12);
    document.cookie = hideCookieBannerKey + '=1; expires=' + expires + '; path=/';
});

if (getCookie(hideCookieBannerKey) !== '1') {
    var $cookieBanner = $('#cookie-banner');
    $cookieBanner .removeClass('hide');

    var height = $cookieBanner.height();
    $('footer').css('margin-bottom', height + 'px');
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}